import { OrganizationCompanyRepository } from '@domain/organization-company/repositories/organization-company.repository';
import { OrganizationCompanyRepositoryService } from '../repositories/organization-company.service';

export const OrganizationCompanyProvider = [
  {
    provide: OrganizationCompanyRepository,
    useClass: OrganizationCompanyRepositoryService,
  },
];
